import React, { useContext } from 'react'
import { navigate } from 'gatsby'

import { AppContext } from '../../containers/App'

import Layout from '../Layout'
import { permissions as p } from '../../utils/constants'
import withPermissions from '../../containers/withPermissions'
import { PlaceHolder } from '../../utils/withLoading'
import UnitsList from './UnitsList'
import { User } from './utils'

const decorate = withPermissions

const UnitsWaypoint = ({ hasPermissions }) => {
  const user = useContext<Pick<User, 'unitId'>>(AppContext)

  hasPermissions(p.diagnosticModule) ||
    (hasPermissions(p.unitManagement)
      ? navigate(`/app/units/${user.unitId}`)
      : navigate(`/app/units/panel/${user.unitId}`))

  return hasPermissions(p.diagnosticModule) ? (
    <UnitsList />
  ) : (
    <Layout>
      <PlaceHolder />
    </Layout>
  )
}

export default decorate(UnitsWaypoint)
